import { Component } from '@angular/core';
import { IonicPage, LoadingController, ToastController } from 'ionic-angular';
import { APIOnLine } from '../../services/api/api.services';
import { Proxy } from '../../services/proxy/proxy.service';
import { PopoverController } from 'ionic-angular/components/popover/popover-controller';
import { Popover } from 'ionic-angular/components/popover/popover';
import { NuevoMenuDerechoComponent } from '../../components/nuevo-menu-derecho/nuevo-menu-derecho';
import { AuxiliaresPage } from '../auxiliares/auxiliares';
import { EntrenadoresPage } from '../entrenadores/entrenadores';
import { JugadoresPage } from '../jugadores/jugadores';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { PaginaBasica } from '../../models/PaginaBase';
import { OtrosAuxiliaresPage } from '../otros-auxiliares/otros-auxiliares';

@IonicPage()
@Component({
  selector: 'page-alineacion',
  templateUrl: 'alineacion.html',
})
export class AlineacionPage extends PaginaBasica {

  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;

  public auxiliaresRoot: any;
  public entrenadoresRoot: any;
  public jugadoresRoot: any;
  public otrosauxiliaresRoot: any;

  constructor(
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    private popOverCtrl: PopoverController,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
    this.auxiliaresRoot = AuxiliaresPage;
    this.entrenadoresRoot = EntrenadoresPage;
    this.jugadoresRoot = JugadoresPage;
    this.otrosauxiliaresRoot = OtrosAuxiliaresPage;
  }

  ionViewDidLoad() {
    console.log('ionViewDidEnter AlineacionPage');
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();
  }

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent, {
      actual: AlineacionPage,
      primeraParte: true
    });

    popover.present({
      ev: event
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/alineacion/alineacion.ts